import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getRequests } from "../../../actions/requestAction";
import CardAnalytics from "../CardAnalytics";
import axios from "axios";

export default function TopCards() {
  const dispatch = useDispatch();
  const requests = useSelector((state) => state.requests);

  const [totalorders, setTotalOrders] = useState(0);
  const [totalordersUS, setTotalOrdersUS] = useState(0)

  const [totalusers, setTotalUsers] = useState(0);
  const [totalUsersUS, setTotalUsersUS] = useState(0);

  const [totalrestaurants, setTotalRestaurants] = useState(0);
  const [totalrestaurantsUS, setTotalRestaurantsUS] = useState(0);

  const getData = async (country) => {
    const [orders, ordersUS, users, restaurants, restaurantsUS] = await Promise.all([
      axios.get(`/api/calculations/orders/count-by-country?country=Canada`),
      axios.get(`/api/calculations/orders/count-by-country?country=United States`),
      axios.get(`/api/calculations/users/count-by-country`),
      axios.get(`/api/calculations/restaurants/${country}`),
      axios.get(`/api/calculations/restaurants/United States`)
    ]);
    setTotalOrders(orders.data.count);
    setTotalOrdersUS(ordersUS.data.count);
    setTotalUsers(users.data[1].usersCount);
    setTotalUsersUS(users.data[0].usersCount);
    setTotalRestaurants(restaurants.data.totalrestaurants);
    setTotalRestaurantsUS(restaurantsUS.data.totalrestaurants);
  };

  useEffect(() => {
    dispatch(getRequests);
  }, [dispatch]);

  useEffect(() => {
    getData('Canada');
  }, []);

  return (
    <div className="row">
      <CardAnalytics
        title="Requests"
        description="Total requests from chef"
        value={Object.keys(requests).length}
        status="text-secondary"
      />
      <CardAnalytics
        title="Users"
        description="Total users"
        value={totalusers}
        valueUS={totalUsersUS}
        status="text-secondary"
      />
      <CardAnalytics
        title="Orders"
        value={totalorders}
        valueUS={totalordersUS}
        status="text-secondary"
      />
      <CardAnalytics
        title="Restaurants"
        description="Total onboarded Restaurants"
        value={totalrestaurants}
        valueUS={totalrestaurantsUS}
        status="text-secondary"
      />
    </div>
  );
}
